module.exports = __webpack_public_path__ + "static/social_dashboard-3afae1935817973e1aac085ba9cceed3.svg";